document.addEventListener('DOMContentLoaded', function () {
  const eta_section = document.querySelectorAll('.eta-section');
  const min_express = document.querySelector('#express-start').dataset.days;
  const max_express = document.querySelector('#express-end').dataset.days;

  const min_express_new_value = document.querySelector('#express-start');
  const max_express_new_value = document.querySelector('#express-end');

  const expressEndMonth = document.querySelector('#expressEndMonth');
  const expressEndDay = document.querySelector('#expressEndDay');

  const cartETA = document.getElementById('cartETA');
  
  const currentDate = new Date();

  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const currentDayIndex = currentDate.getDay();
  const currentDay = daysOfWeek[currentDayIndex];

  const futureDate = new Date(currentDate);
  const options = { weekday: 'short', month: 'short', day: 'numeric' };
  const month_option = { month: 'short' };
  const day_option = { day: 'numeric' };

  
  futureDate.setDate(currentDate.getDate() + parseInt(min_express));
  let min_express_new_value_formattedDate = futureDate.toLocaleDateString(undefined, options);
  let minDay = futureDate.toLocaleDateString(undefined, day_option);
  let minMonth = futureDate.toLocaleDateString(undefined, month_option);
  min_express_new_value.textContent = min_express_new_value_formattedDate;

  futureDate.setDate(currentDate.getDate() + parseInt(max_express));
  let max_express_new_value_formattedDate = futureDate.toLocaleDateString(undefined, options);
  let maxDay = futureDate.toLocaleDateString(undefined, day_option);
  let maxMonth = futureDate.toLocaleDateString(undefined, month_option);
  max_express_new_value.textContent = max_express_new_value_formattedDate;

  if(expressEndDay){
    expressEndDay.textContent = futureDate.toLocaleDateString(undefined, day_option);
  }

  if(expressEndMonth){
    expressEndMonth.textContent = futureDate.toLocaleDateString(undefined, month_option);
  }

  if(minMonth === maxMonth){
    cartETA.textContent = minDay + "-" + maxDay + " " + maxMonth;
  }else{
    cartETA.textContent = minDay + minMonth + ", " + maxDay + " " + maxMonth;
  }
});